import { lighten, rgba } from "polished";
import { useTheme } from "styled-components";
import { NAMESPACE } from "../constants";
import { steelGreyA400 } from "../colors";
export const getColorFromTheme = (colorKey, { theme, colorScheme = theme.defaults.colorScheme, palette = theme.defaults.palette, opacity, lighten: lightenValue }) => {
    const fullActivePath = theme.colorSchemes[colorScheme][palette];
    const fullDefaultPath = theme.colorSchemes[colorScheme][theme.defaults.palette];
    if (fullActivePath === undefined) {
        console.error(`"${palette}" palette is not defined in within the "${colorScheme}" or "${theme.defaults.colorScheme}" color scheme`);
        return steelGreyA400;
    }
    const value = fullActivePath[colorKey] || fullDefaultPath[colorKey];
    if (value === undefined) {
        console.error(`Color "${colorKey}" is not defined in "${palette}" palette within "${colorScheme}" or "${theme.defaults.colorScheme}" color scheme`);
        return steelGreyA400;
    }
    if (opacity !== undefined) {
        return rgba(value, opacity);
    }
    if (lightenValue !== undefined) {
        return lighten(lightenValue, value);
    }
    return value;
};
// Styled Component Helper
export const color = (colorKey, options = {}) => (props) => {
    const theme = props.theme[NAMESPACE];
    return getColorFromTheme(colorKey, {
        theme,
        colorScheme: options.colorScheme || props.colorScheme || theme.defaults.colorScheme,
        palette: options.palette || props.palette || theme.defaults.palette,
        opacity: options.opacity,
        lighten: options.lighten
    });
};
// React Hook version
export const useColor = (colorKey, options) => {
    const theme = useTheme()[NAMESPACE];
    return getColorFromTheme(colorKey, {
        theme,
        colorScheme: options?.colorScheme,
        palette: options?.palette
    });
};
